import React from "react";

const StatusCards = ({ cards }) => {
  const statusClasses = {
    completed: "border-green-500 bg-white",
    "in-progress": "border-yellow-300 bg-white",
    "not-started": "border-gray-400 text-gray-500 bg-white opacity-60",
  };


  return (
    <div className="flex gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`flex flex-col justify-between w-full sm:w-1/4 p-4 rounded-lg shadow-md border-l-4 ${
            statusClasses[card.status]
          }`}
        >
          <div>
            <h3 className="text-xl font-bold">{card.title}</h3>
            <p className="mt-2 text-sm">{card.statusLabel}</p>
          </div>
          {/* <div className={`h-2 mt-4 rounded ${barClasses[card.status]}`}></div> */}
        </div>
      ))}
    </div>
  );
};

export default StatusCards;
